
export const elaborate = (reviewHistory) => {
  let lastUsedReviews = {};
  reviewHistory.forEach((element, index) => {
    let lastReview = lastUsedReviews[element['card_id']]
    if (lastReview !== undefined) {
      element['delta_t'] = element['submitted_time'] - lastReview['submitted_time']
      element['delta_r'] = element['review'] - lastReview['review']
      element['last_correct'] = lastReview['was_correct']
    } else {
      element['delta_t'] = 0
      element['delta_r'] = 0
      element['last_correct'] = 0
    }
    element['visible_time'] = element['submitted_time'] - element['showed_time']
    lastUsedReviews[element['card_id']] = element
  })
  return reviewHistory;
}
